export const GET_HALTMAP_DATA_REQUEST = `GET_HALTMAP_DATA_REQUEST`;
export const GET_HALTMAP_DATA_SUCCESS = `GET_HALTMAP_DATA_SUCCESS`;
export const GET_HALTMAP_DATA_FAILURE = `GET_HALTMAP_DATA_FAILURE`;
